import { StyleSheet } from "aphrodite";
import { space } from "main/javascripts/styles/base/spaceStyle";
import {
  accentColor,
  borderColor,
  textColor,
} from "main/javascripts/styles/base/colorStyle";
import {
  fontSize,
  fontWeight,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";
import { moreThanBreakpoint } from "main/javascripts/styles/base/responsiveStyle";

export interface IStyle {
  block: any;
  progress: any;
  bar: any;
  barActive: any;
  barActive1: any;
  barActive2: any;
  barActive3: any;
  item: any;
  itemNumber: any;
  itemNumberDone: any;
  itemNumberActive: any;
  itemText: any;
  itemTextActive: any;
  title: any;
}

export const DynamicPackageStepIndicatorStyle: IStyle = StyleSheet.create({
  block: {
    padding: `${space.atom2x} 0 ${space.atom}`,
  },
  progress: {
    textAlign: "center",
    padding: `${space.atom} 0`,
    margin: "0 auto",
    position: "relative",
    width: "318px",
    [moreThanBreakpoint("tablet")]: {
      width: "420px",
    },
  },
  bar: {
    position: "absolute",
    top: "calc(16px + 0.5rem)",
    left: "53px",
    height: "6px",
    width: "212px",
    background: borderColor.secondaryLightColor,
    transform: "translateY(-50%)",
    [moreThanBreakpoint("tablet")]: {
      left: "70px",
      width: "280px",
    },
  },
  barActive: {
    position: "absolute",
    top: "calc(16px + 0.5rem)",
    left: "53px",
    height: "6px",
    width: "212px",
    background: accentColor.primaryColor,
    transform: "translateY(-50%)",
    transformOrigin: "top left",
    [moreThanBreakpoint("tablet")]: {
      left: "70px",
      width: "280px",
    },
  },
  barActive1: {
    transform: "translateY(-50%) scaleX(0)",
  },
  barActive2: {
    transform: "translateY(-50%) scaleX(0.5)",
  },
  barActive3: {
    transform: "translateY(-50%) scaleX(1)",
  },
  item: {
    display: "inline-block",
    textAlign: "center",
    width: "106px",
    verticalAlign: "top",
    [moreThanBreakpoint("tablet")]: {
      width: "140px",
    },
  },
  itemNumber: {
    position: "relative",
    width: "32px",
    height: "32px",
    textAlign: "center",
    lineHeight: "24px",
    fontSize: fontSize.subHeading,
    fontWeight: fontWeight.bold,
    background: borderColor.secondaryLightColor,
    borderRadius: "16px",
    border: `4px solid ${borderColor.secondaryLightColor}`,
    display: "block",
    margin: "0 auto",
    boxSizing: "border-box",
    zIndex: 1,
  },
  itemNumberDone: {
    color: "#fff",
    background: accentColor.primaryColor,
    borderColor: accentColor.primaryColor,
  },
  itemNumberActive: {
    color: accentColor.primaryColor,
    background: "#fff",
    borderColor: accentColor.primaryColor,
  },
  itemText: {
    padding: `${space.atom0_5x} ${space.atom0_5x} 0`,
    fontSize: fontSize.smallest,
    fontWeight: fontWeight.bold,
    textAlign: "center",
    color: textColor.disabledColor,
    display: "inline-block",
    [moreThanBreakpoint("tablet")]: {
      fontSize: fontSize.caption,
    },
  },
  itemTextActive: {
    color: textColor.primaryDarkColor,
  },
  title: {
    fontSize: fontSize.mediumHeading,
    lineHeight: lineHeight.mediumHeadline2,
    fontWeight: fontWeight.bold,
    textAlign: "center",
    letterSpacing: "0.05em",
    padding: `${space.atom} ${space.atom2x} 0`,
    [moreThanBreakpoint("tablet")]: {
      fontSize: fontSize.headline,
      lineHeight: lineHeight.headline2,
    },
  },
});
